<template>
  <div>
    <v-card class="mx-auto ml-5 my-5 mx-5 mr-5" outlined>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr class="orange darken-1">
              <th colspan="10" class="text-center">
                <span class="white--text text-h6"
                  >ENQUIRY FOLLOW UP REPORT</span
                >
              </th>
            </tr>
            <tr>
              <th class="text-left">ENGINEER</th>
              <th class="text-left">ENQUIRY</th>
              <th class="text-left">ACT ENQUIRY</th>
              <th class="text-left">FOLLOW UP</th>
              <th class="text-left">NEGOTIATION</th>
              <th class="text-left">CONFIRM</th>
              <th class="text-left">FOL UP CLOSED</th>
              <th class="text-left">LOST</th>
              <th class="text-left">BILLED</th>
              <th class="text-left">RESCHDULED</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(record, m) in enquiryFollowup.records" :key="m">
              <td>{{ record.name }}</td>
              <td>{{ record.enquiryValue }}</td>
              <td>{{ record.totalEnquirystatusvalue }}</td>
              <td>{{ record.enquiryFollowupvalue }}</td>
              <td>{{ record.enquiryNegotiationvalue }}</td>
              <td>{{ record.enquiryConfirmvalue }}</td>
              <td>{{ record.enquiryFoloupclosedvalue }}</td>
              <td>{{ record.enquiryLostvalue }}</td>
              <td>{{ record.enquiryBilledvalue }}</td>
              <td>{{ record.enquiryReschduledvalue }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>

    <v-card class="mx-auto ml-5 my-5 mx-5 mr-5" outlined>
      <highcharts :options="chartOptions" ref="highcharts"></highcharts>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src

import { mapGetters, mapActions } from "vuex";
import { VUE_APP_BASEURL } from "../utils/api";
import axios from "axios";
import store from "../store";

export default {
  name: "EnquiryFollowupReport",
  props: [
    "selectedsegment",
    "selectedsalesengineer",
    "selectedregion",
    "selectedproductgroup",
    "selecteddaterange"
  ],
  data: () => ({
    chartOptions: {
      chart: {
        type: "column"
      },
      title: {
        text: "ENQUIRY FOLLOWUP REPORT"
      },
      subtitle: {
        text: ""
      },
      xAxis: {
        categories: ["REPORT"],
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: ""
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [{}],
      credits: {
        enabled: false
      }
    }
  }),
  components: {},
  computed: {
    ...mapGetters(["getEnquiryfollowupreportdata"]),
    enquiryFollowup: function() {
      //console.log(this.getEnquiryfollowupreportdata);
      return this.getEnquiryfollowupreportdata;
    }
  },
  mounted() {},
  created() {
    const filterData = [];
    this.enquiryFollowupreport(filterData);
    this.enquiryfollowupchartload(this.chartOptions);
  },
  methods: {
    ...mapActions(["enquiryFollowupreport"]),
    enquiryfollowupchartload(chartOptions) {
      const filterData = [];
      axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getters.UserToken
        },
        url: VUE_APP_BASEURL + "dashboard/enquiryfollowup-report-chart",
        data: {
          segment: filterData.segment,
          salesengineer: filterData.salesengineer,
          fromdate: filterData.fromDate,
          todate: filterData.toDate
        }
      })
        .then(function(response) {
          // console.log(response.data.response.reportDates);
          chartOptions.series =
            response.data.response.enquiryFollowupbarchartData;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    /*filterEnquiryFollowupReport() {
      const filterData = {
        segment: this.selectedsegment,
        salesengineer: this.selectedsalesengineer,
        fromDate: this.selectedfromDate,
        toDate: this.selectedtoDate,
      };
      this.enquiryFollowupreport(filterData);
      setTimeout(() => {
        this.chartOptions.series=this.enquiryFollowup.enquiryFollowupbarchartData;
        }, 3000)
  },*/

    filterEnquiryFollowupReport() {
      const filterData = {
        segment: this.selectedsegment,
        salesengineer: this.selectedsalesengineer,
        daterange: this.selecteddaterange,
        region: this.selectedregion,
        productgroup: this.selectedproductgroup
      };
      const chartOptions = this.chartOptions;
      axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getters.UserToken
        },
        url: VUE_APP_BASEURL + "dashboard/enquiryfollowup-report-chart",
        data: {
          segment: filterData.segment,
          salesengineer: filterData.salesengineer,
          daterange: filterData.daterange,
          region: filterData.region,
          productgroup: filterData.productgroup
        }
      })
        .then(function(response) {
          // console.log(response);
          chartOptions.series =
            response.data.response.enquiryFollowupbarchartData;
        })
        .catch(function(error) {
          console.log(error);
          console.log(error.response);
        });

      this.enquiryFollowupreport(filterData);
    }
  }
};
</script>
